<selectable-widget
  #sw
  class="card-grey flex flex-col gap-4 p-4">
  <table class="w-full text-left">
    <thead>
      <tr class="text-surface-500">
        <th class="pb-2 font-normal" i18n>FACILITY</th>
        <th class="pb-2 font-normal" i18n>ROLE</th>
        <th class="pb-2 font-normal" i18n>MASTER SERVICER</th>
        <th class="pb-2 font-normal" i18n>LAST CUT-OFF DATE</th>
        <th class="pb-2 font-normal" i18n>TAGS</th>
        <th class="pb-2 text-right font-normal" i18n>FACILITY SIZE</th>
        <th class="pb-2 text-right font-normal" i18n>YOUR COMMITMENT</th>
        <th class="pb-2 text-right font-normal" i18n>% OF AUM</th>
        <th class="pb-2 font-normal" i18n>CO-LENDERS</th>
      </tr>
    </thead>

    <tbody>
      <!--
        `track $index` y no el número de fideicomiso: dos facilities sin
        número comparten llave, y Angular 18 tira NG0955 en vez de pintar la
        tabla. El mismo riesgo tiene un trust con dos tramos.
      -->
      @for (row of visibleRows(); track $index) {
        <tr class="border-t border-surface-200 align-top">
          <td class="py-3">
            @if (row.route) {
              <a [routerLink]="row.route" class="block font-bold hover:underline">
                {{ row.originator }}
              </a>
              <a [routerLink]="row.route" class="block font-mono text-sm text-surface-500">
                {{ row.trustNumber }}
              </a>
            } @else {
              <!--
                Sin fideicomiso no hay ficha que abrir. Texto plano, sin enlace
                ni cursor de clic, y no alcanzable por teclado: es un no
                funcional explícito de accesibilidad, no un detalle.
              -->
              <span class="block font-bold">{{ row.originator }}</span>
              <small class="text-surface-500" i18n>no trust yet</small>
            }
          </td>

          <td class="py-3">
            @if (row.role) {
              <span>{{ row.role }}</span>
            } @else {
              <small class="text-surface-500" i18n>Role not set</small>
            }
            @if (row.participationPct !== null && row.participationPct !== undefined) {
              <small class="block text-surface-500">
                {{ row.participationPct | number: '1.0-1' }}%
              </small>
            } @else {
              <!-- Una sindicada sin % no es 100%: adivinarlo infla la
                   exposición que el analista cree tener. -->
              <small class="block text-surface-500" i18n>% not set</small>
            }
          </td>

          <td class="py-3">
            {{ row.masterServicer || '—' }}
          </td>

          <td class="py-3">
            @if (row.reportedAt) {
              <span [class.text-amber-800]="row.outdated">
                {{ row.reportedAt | date: 'dd/MM/yyyy' }}
              </span>
              @if (row.outdated) {
                <span class="ml-1 text-xs text-amber-800" i18n>Outdated</span>
              }
            } @else {
              <span class="text-surface-500" i18n>No report yet</span>
            }
            <small class="block text-surface-500">
              @if (row.cadence) {
                {{ row.cadence }} <span i18n>reporting</span>
              } @else {
                <span i18n>Reporting frequency not set</span>
              }
            </small>
          </td>

          <td class="py-3">
            @if (row.tags.length) {
              <div class="flex flex-wrap gap-1">
                @for (tag of row.tags; track tag.name) {
                  <span class="rounded bg-surface-200 px-2 py-0.5 text-xs">
                    {{ tag.name }}
                  </span>
                }
              </div>
            } @else if (tagsAreComplete()) {
              <small class="text-surface-500">—</small>
            } @else {
              <!-- El listado de compañías vino recortado (tope de 100), así
                   que vacío no significa "sin etiquetas": no sabemos. -->
              <small class="text-surface-500" i18n>Tags not loaded</small>
            }
          </td>

          <td class="py-3 text-right">
            <currency-amount [value]="row.facilitySize" [currency]="currency()" />
          </td>

          <td class="py-3 text-right font-bold">
            @if (row.commitment !== null && row.commitment !== undefined) {
              <currency-amount [value]="row.commitment" [currency]="currency()" />
            } @else {
              <!-- Dato ausente se dice, nunca se pinta $0. -->
              <span class="font-normal text-surface-500">—</span>
            }
          </td>

          <td class="py-3 text-right">
            @if (row.aumPct !== undefined) {
              {{ row.aumPct | number: '1.0-1' }}%
            } @else {
              <span class="text-surface-500">—</span>
            }
          </td>

          <td class="py-3">
            @if (row.coLenders.length) {
              {{ row.coLenders.join(', ') }}
            } @else {
              <small class="text-surface-500">—</small>
            }
          </td>
        </tr>
      } @empty {
        <tr>
          <td colspan="9" class="py-6 text-center text-surface-500" i18n>
            No facilities to show.
          </td>
        </tr>
      }
    </tbody>
  </table>
</selectable-widget>

@if (showsPaginator()) {
  <!--
    Fuera del borde de la tabla, con aire propio: así se lee como control y no
    como otra fila.
  -->
  <div class="mt-2 flex items-center justify-between">
    <small class="text-surface-500" i18n>Showing 10 per page</small>
    <p-paginator
      [rows]="pageSize"
      [totalRecords]="rows().length"
      [first]="currentPage() * pageSize"
      [pageLinkSize]="3"
      [showFirstLastIcon]="false"
      (onPageChange)="goToPage($event.page ?? 0)" />
  </div>
}
